module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Dee Harrison-Schultz is a licensed clinical counselor for the past 25 years. She is experienced in working with a variety of disorders, within the prison system, as well as in an outpatient setting. These experiences sparked an intense curiosity in forensics and criminology. "), _c('em', [_vm._v("Darwin Was Right")]), _vm._v(" is her premier novel. She lives with her husband, David Schultz, and their two rescue dogs, Zeke and Zoe. They currently divide their time between Spruce Pine, North Carolina, and Punta Gorda, Florida.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0